import React, { useEffect } from 'react'
import { useAppDispatch } from 'app/hooks'
import { Dashboard } from 'schemas/DashboardSchema'
import { useDashboardData, useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { getWidgetPostSoundbites } from 'features/widget/asyncThunks'
import { toFilter } from 'utils/widgetUtil'
import { createDocumentSearch } from 'utils/runSearchUtil'
import { RunSearch } from 'schemas/action/RunSearchSchema'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'
import { PopularLinksWidgetsType } from '../../../types'

interface RunSearchEffectProps {
  widgetId: number
  url?: string
  children: React.ReactElement
}

const createSearch = (
  widgetSetting: PopularLinksWidgetsType,
  dashboardData: Dashboard,
  url?: string
): RunSearch[] => {
  const filter = toFilter(widgetSetting)
  if (filter && url) {
    filter.mentionedUrls = []
    filter?.mentionedUrls?.push({
      url
    })
  }

  return [
    createDocumentSearch(
      dashboardData.id!,
      dashboardData.name!,
      [widgetSetting.selectedTopic.topicId!],
      filter,
      widgetSetting.precision!,
      'TIME',
      10,
      true,
      false
    )
  ]
}

const RunSearchEffect = ({ widgetId, url, children }: RunSearchEffectProps): React.ReactElement => {
  const widgetSetting = useDashboardWidgetSetting<PopularLinksWidgetsType>(widgetId)
  const dashboardData = useDashboardData()

  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp(widgetId)

  useEffect(() => {
    const search = createSearch(widgetSetting, dashboardData!, url)

    dispatch(
      getWidgetPostSoundbites({
        searches: search,
        widgetId: widgetSetting.widgetId!,
        url,
        timestamp: refreshTimestamp
      })
    )
  }, [widgetSetting, dashboardData, dispatch, refreshTimestamp, url])
  return children
}

export default RunSearchEffect
